import { render, staticRenderFns } from "./instance_vulnerability_report.vue?vue&type=template&id=41fd67ce&"
import script from "./instance_vulnerability_report.vue?vue&type=script&lang=js&"
export * from "./instance_vulnerability_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports